"use client";

import { type ReactNode, createContext, useContext, useRef } from "react";
import { useStore } from "zustand";
import { AidaStore, createAidaStore } from "@/stores/aidaAssistantStore";
export type AidaStoreApi = ReturnType<typeof createAidaStore>;
export const AidaStoreContext = createContext<AidaStoreApi | undefined>(undefined);
export interface AidaStoreProviderProps {
  children: ReactNode;
}
export const AidaStoreProvider = ({
  children
}: AidaStoreProviderProps) => {
  const storeRef = useRef<AidaStoreApi>();
  if (!storeRef.current) {
    storeRef.current = createAidaStore();
  }
  return <AidaStoreContext.Provider value={storeRef.current} data-sentry-element="unknown" data-sentry-component="AidaStoreProvider" data-sentry-source-file="AidaStoreProvider.tsx">
      {children}
    </AidaStoreContext.Provider>;
};
export const useAidaStore = <T,>(selector: (store: AidaStore) => T): T => {
  const aidaStoreContext = useContext(AidaStoreContext);
  if (!aidaStoreContext) {
    throw new Error(`useAidaStore must be used within AidaStoreProvider`);
  }
  return useStore(aidaStoreContext, selector);
};